import { Component, OnInit } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { Nivel } from '../../_models/nivel';
import { NivelesService } from '../../_services/niveles.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';

@Component( {
  templateUrl: 'niveles-listado.component.html',
  selector: 'app-niveles'
} )
export class NivelesListadoComponent implements OnInit {

  columnas: any[];
  busqueda: string;
  niveles: Nivel[];
  carNiveles = true;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService,
               private nivelesService: NivelesService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/niveles' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_NIVEL' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_HABILITADO' ), sort: true },
      { field: 'indicadorAprueba', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_APRUEBA' ), sort: true },
      { field: 'indicadorManejaDctoTasa', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_DCTOTASA' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'NIVELES.LBL_ACCIONES' ), sort: true },
    ];
    this.nivelesService.listadoVerificaRangos().subscribe( res => {
      this.niveles = res;
      this.carNiveles = false;
    } );
  }

  add(): void {
    this.router.navigate( [ 'apl/niveles/agregar' ] );
  }

  update( nivel: Nivel ): void {
    this.router.navigate( [ 'apl/niveles/actualizar/' + nivel.idNivel ] );
  }

  view( nivel: Nivel ): void {
    this.router.navigate( [ 'apl/niveles/detalle/' + nivel.idNivel ] );
  }

  setSearch(): void {
    this.navServicio.setSearch( 'niveles.component', this.busqueda );
  }

  unlink( nivel: Nivel ) {
    this.router.navigate( [ 'apl/niveles/rangoUsuario/' + nivel.idNivel ] );
  }

}
